import { createApp, reactive } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css';

import VueGtag from 'vue-gtag-next'
import { useGtag } from 'vue-gtag-next'

import Papa from 'papaparse' 

import VueTippy from 'vue-tippy'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light.css'

import 'leaflet/dist/leaflet.css'

//import { VueFlow } from '@vue-flow/core';

import colles from '@/json/dades_completes_mosaic.json'
import escutsSprite from '@/assets/escuts/escuts_sprite.webp'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import EtiquetaCastell from './components/castells/EtiquetaCastell.vue';
import RetolCastell from './components/castells/RetolCastell.vue';
import MiniaturaCastell from './components/castells/MiniaturaCastell.vue';
import FilaCastell from './components/castells/FilaCastell.vue';

import AixetaBanner from './components/AixetaBanner.vue';

import { 

  faGraduationCap,
  faFire,
  faHouse,

  faPeopleGroup,
  faHourglassHalf,
  faLightbulb,
  faChartPie,
  faFilm,
  faArrowsToDot,

  faSeedling,
  faCross,
  faEarthAmericas,

  faEye,
  faAddressCard,
  faTriangleExclamation,
  faCircleQuestion,
  faTrophy,
  faStopwatch,
  faEnvelope,
  faCamera,

  faArrowUpRightFromSquare,
  faArrowsUpDown,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faXmark,
  faCheck,
  faBars,
  faAsterisk,
  
  faLink,
  faGlobe,
  
  faStar,
  faStarHalf

} from '@fortawesome/free-solid-svg-icons'

import { faWikipediaW,
  faXTwitter,
  faInstagram,
  faFacebook,
  faYoutube
} from '@fortawesome/free-brands-svg-icons'

import {
  diff,
  rgbaToLab
} from "color-diff";


import convert from "color-convert";


import './registerServiceWorker'

//import './registerServiceWorker'

library.add(
  faYoutube,
  faChevronLeft,
  faArrowUpRightFromSquare,
  faCircleQuestion,
  faTriangleExclamation,
  faXmark,
  faArrowsUpDown,
  faChevronRight, 
  faLink, 
  faEnvelope,
  faInstagram,
  faAddressCard, 
  faChevronDown, 
  faCheck, 
  faFire, 
  faSeedling, 
  faGlobe, 
  faWikipediaW, 
  faXTwitter,
  faFacebook,
  faEye,
  faBars,
  faEarthAmericas,
  faGraduationCap,
  faCross,
  faHouse,
  faTrophy,
  faStopwatch,
  faAsterisk,
  faCamera,
  faStar,
  faStarHalf,
  
  faPeopleGroup,
  faHourglassHalf,
  faLightbulb,
  faChartPie,
  faFilm,
  faArrowsToDot
)
const version = "1.5.0"
const app = createApp(App)

app.component('font-awesome-icon', FontAwesomeIcon)

const vistaMobil = window.innerWidth <= 1024;

/* if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('ServiceWorker registered: ', registration)
      })
      .catch(error => {
        console.log('ServiceWorker registration failed: ', error)
      })
  })
} */

if ('serviceWorker' in navigator) {
navigator.serviceWorker.getRegistrations().then(function(registrations) {
  for (let registration of registrations) {
    registration.unregister();
  }
});
if (window.caches) {
  caches.keys().then(function(names) {
    for (let name of names) caches.delete(name);
  });
}
}

const defaultConfig = {
  config_version:3,
  mosaic:{
    
    ordre:"nom",
    mida: vistaMobil? 50:80,
    tipus:["convencional","universitaria","internacional"],
    estat:["activa","formacio","desapareguda"],
    seccions_tipus:false,
    seccions_estat:false,
    escuts:false,
    patrons:false,
    icones_tipus:true,
    icones_estat:false,
    nomes_desaparegudes:true,
    nom_color:false
  },
  llista_colles:{
    ordre:"nom",
    tipus:["convencional","universitaria","internacional"],
    estat:["activa","formacio","desapareguda"],
  },
  linia_temporal:{
    ordre:"fundacio",
    origen:1791,
    compacte:false,
    tipus:["convencional","universitaria","internacional"],
    estat:["activa","formacio","desapareguda"],
  },
  mapa:{
    escuts:false,
    icones_tipus:true,
    icones_estat:false,
    tipus:["convencional","universitaria","internacional"],
    estat:["activa","formacio"],
  },
  barometre_uni:{
    punts:false
  }
}

let savedConfig = JSON.parse(localStorage.getItem('configVisualitzacio'))
if(!savedConfig||savedConfig.config_version !== defaultConfig.config_version){
  localStorage.removeItem('configVisualitzacio')
  savedConfig = null
}

const configVisualitzacio= reactive(savedConfig??defaultConfig)

const defaultTitle = document.title
const defaultDescription = document.querySelector('meta[name="description"]')?.getAttribute('content') || ''

const gtag = useGtag()

router.afterEach((to) => {

  gtag.pageview({
    page_path: to.fullPath,
    page_title: document.title,
    page_location: window.location.href 
  });
  // Set title
  document.title = to.meta?.title || defaultTitle

  // Set description
  const description = to.meta?.description || defaultDescription
  let descriptionTag = document.querySelector('meta[name="description"]')

  if (descriptionTag) {
    descriptionTag.setAttribute('content', description)
  } else {
    descriptionTag = document.createElement('meta')
    descriptionTag.setAttribute('name', 'description')
    descriptionTag.setAttribute('content', description)
    document.head.appendChild(descriptionTag)
  }
})

app.provide('dades', colles)
app.provide('escutsSprite', escutsSprite)
app.provide('config',configVisualitzacio)
app.provide('version', version)

app.use(VueGtag, {
  property: { id: 'G-KX3YFYQ9YH' }  
}, router)

//app.use(VueFlow)
app.use(Papa)
app.use(router)
app.use(
    VueTippy,
    // optional
    {
      directive: 'tippy', // => v-tippy
      component: 'tippy', // => <tippy/>
      componentSingleton: 'tippy-singleton', // => <tippy-singleton/>,
      defaultProps: {
        placement: 'bottom',
        allowHTML: true,
        trigger: "click mouseenter focusin",
        interactive: true,
        arrow:false,
        offset:[0,3],
        zIndex:9999,
      }, // => Global default options * see all props
    }
  )


app.config.globalProperties.$diff = diff
app.config.globalProperties.$rgbaToLab = rgbaToLab

app.config.globalProperties.$convert = convert

app.component('EtiquetaCastell',EtiquetaCastell)
app.component('RetolCastell',RetolCastell)
app.component('MiniaturaCastell',MiniaturaCastell)
app.component('FilaCastell',FilaCastell)

app.component('AixetaBanner',AixetaBanner)


app.mount('#app')
